const translation = {
	PageSize: 'Tamaño de página',
	PageOrientation: 'Orientación de página',
	Format: 'Formato',
	DPI: 'DPI',
	Generate: 'Generar'
};

export default translation;
